import React from "react";
import { TrendingUp } from "lucide-react";

export default function LoginPage() {
  const startGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div
      data-testid="login-page"
      className="min-h-screen flex items-center justify-center px-6"
      style={{ background: "#0A0A0A" }}
    >
      <div className="w-full max-w-sm panel p-8 text-center">
        <div className="w-12 h-12 border border-[#3F3F46] flex items-center justify-center mx-auto mb-5">
          <TrendingUp size={22} className="text-[#00E676]" strokeWidth={2.5} />
        </div>
        <h1 className="text-2xl font-bold tracking-tight mb-1">
          ROLL<span className="text-[#00E676]">.</span>OPS
        </h1>
        <p className="label-cap mb-8">Covered Call Rolling Terminal</p>
        <button
          data-testid="google-login-btn"
          onClick={startGoogleLogin}
          className="w-full bg-white text-black hover:bg-[#E5E7EB] transition-colors rounded-sm px-4 py-3 text-sm font-medium flex items-center justify-center gap-3"
        >
          <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
            <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.4-.4-3.5z"/>
            <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 16 18.9 13 24 13c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/>
            <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2c-2 1.4-4.5 2.4-7.2 2.4-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z"/>
            <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4.1 5.6l6.2 5.2c-.4.4 6.6-4.8 6.6-14.8 0-1.2-.1-2.4-.4-3.5z"/>
          </svg>
          Sign in with Google
        </button>
        <p className="text-[11px] text-[#71717A] mt-6 leading-relaxed">
          We use your Google account only to identify you. Your covered-call positions stay private to your account.
        </p>
      </div>
    </div>
  );
}
